import { pathgen } from 'object-path-generator';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useDuplicateRelationship } from '~/hooks/useDuplicateRelationship';
import { useStoreActions } from '~/store/store-context';
export const useArchiveProposalTestIds = pathgen('useArchiveProposalTestIds');
export const useArchiveProposal = function useArchiveProposal() {
    let { onSuccess, biCode } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { createDraftFromRelationship } = useDuplicateRelationship();
    const { mutate, isLoading } = useMutationState({
        mutationFn: async (param)=>{
            let { draftId, relationshipId } = param;
            let newDraftId;
            if (draftId) {
                newDraftId = await api.draft.duplicate(draftId);
            } else {
                newDraftId = await createDraftFromRelationship(relationshipId, {
                    strategy: 'withdraw-to-edit'
                });
            }
            await api.draft.archive(newDraftId);
            return api.relationship.cancelProposal(relationshipId);
        },
        toasts: {
            successMessage: 'Proposal archived successfully',
            successTestId: useArchiveProposalTestIds.SuccessToast(),
            errorMessage: 'Failed to archive proposal',
            errorTestId: useArchiveProposalTestIds.ErrorToast()
        },
        onSuccess,
        biCode
    });
    return {
        archive: mutate,
        isLoading
    };
};
